<template>
  <section class="bbs-wrap">
    <slot />
  </section>
</template>


